import React from "react";

import Modal from "../../../components/dialogs/modal";

interface UnlockUserModalProps {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  t: (key: string) => string;
}

const UnlockUserModal = ({
  visible,
  onOk,
  onCancel,
  t
}: UnlockUserModalProps) => (
  <Modal
    open={visible}
    title={t("common.messages.areYouSure")}
    actions={[
      {
        text: t("common.ok"),
        type: "ok",
        action: onOk
      },
      {
        text: t("common.cancel"),
        type: "cancel",
        action: onCancel
      }
    ]}
  >
    <p>
      This will unlock the user, making it possible for him/her to open the door
      in stores again.
    </p>
  </Modal>
);

export default UnlockUserModal;
